export function ActiveUsersIcon({
  className = "size-5",
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M14.714 15.5474C12.1105 18.1509 7.88937 18.1509 5.28587 15.5474C3.98413 14.2456 3.33325 12.5395 3.33325 10.8333C3.33325 9.12718 3.98412 7.42103 5.28587 6.11928C5.28587 6.11928 5.83329 7.49996 7.49996 8.3333C7.49996 6.66663 7.91662 4.16663 9.98815 2.5C11.6666 4.16667 13.4092 4.81454 14.714 6.11928C16.0157 7.42103 16.6666 9.12718 16.6666 10.8333C16.6666 12.5395 16.0157 14.2456 14.714 15.5474Z" stroke="#101828" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8.23215 13.4344C9.20846 14.4107 10.7914 14.4107 11.7677 13.4344C12.2558 12.9462 12.4999 12.3065 12.4999 11.6667C12.4999 11.0268 12.2558 10.387 11.7677 9.89886C11.2826 9.41379 10.6478 9.16972 10.0121 9.16666L9.16654 11.6666L7.49992 11.6667C7.49993 12.3065 7.744 12.9462 8.23215 13.4344Z" stroke="#101828" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}
export const displayName = "ActiveUsersIcon";
